import { useProjectContext } from '@gonfalon/app-context/useProjectContext';
import { useContextKinds as useContextKindsHook } from '@gonfalon/contexts/hooks/useContextKinds';
import invariant from 'tiny-invariant';

// In some cases, useContextKinds is used dependently on a user input, and not the project loader.
// This would be easier if it useProjectKey could be provided via a context without loader
export const useContextKinds = ({ projectKey: providedProjectKey }: { projectKey?: string } = {}) => {
  const projectContext = useProjectContext({ optional: providedProjectKey !== undefined });

  const projectKey = providedProjectKey ?? projectContext?.context.projectKey;

  invariant(
    projectKey !== undefined,
    'Expected projectKey to either be passed in to `useContextKinds` or available in project context',
  );

  return useContextKindsHook(projectKey);
};
